// extracted by mini-css-extract-plugin
export default {"countingContainer":"counting_countingContainer__mi4id","counting":"counting_counting__nqZug","countingText":"counting_countingText__peh-C"};